export enum TaskStatus {
  NotStarted = 0,
  InProgress = 1,
  Paused = 2,
  Completed = 3,
  Reported = 4,
  Idle = 5,
  AbleToContinue = 6,
  Stopped = 7,
}

export enum TaskSource {
  Manual = 1,
  PlanScheduler = 2,
  ShiftProgram = 3,
  TriggerCompletion = 4,
  TriggerScheduled = 5,
  TriggerThreshold = 6,
  IssueTrigger = 7,
  Request = 8,
}

export enum TaskUnassignedReason {
  NoEligibleWorkers = 1,
  NoAvailableMachines = 2,
  CapabilityMismatch = 3,
}

export enum OperationEventKind {
  ShiftStart = 1,
  ShiftProgramRun = 2,
  TaskGenerated = 3,
  TaskStarted = 4,
  TaskCompleted = 5,
  TaskBlocked = 6,
  TriggerFired = 7,
  AlertRaised = 8,
  MachineDown = 9,
  MachineUp = 10,
  BookingCreated = 11,
  PlanProgress = 12,
  Incident = 13,
  Request = 14,
}

export enum OperationEventSeverity {
  Critical = 1,
  Warning = 2,
  Info = 3,
  Success = 4,
}

export enum OperationRequestPriority {
  Low = 1,
  Normal = 2,
  High = 3,
  Critical = 4,
}

export enum OperationRequestStatus {
  Open = 1,
  Acknowledged = 2,
  InProgress = 3,
  Done = 4,
  Declined = 5,
}

export enum OperationRequestSlaState {
  OnTime = 1,
  DueSoon = 2,
  Overdue = 3,
}

export enum OperationRequestLinkedEntityType {
  Task = 1,
  Plan = 2,
  Machine = 3,
  Booking = 4,
}

export enum DepartmentKpiTemplate {
  Mining = 1,
  Plant = 2,
  Maintenance = 3,
  Camp = 4,
  Security = 5,
  Custom = 6,
}

export enum DegradeRule {
  Reduce = 1,
  Pause = 2,
  Skip = 3,
  AlertOnly = 4,
}

export enum OperationNotificationType {
  NewTaskAssigned = 1,
  TaskBlocked = 2,
  TaskReassigned = 3,
  RequestOverdue = 4,
  ShiftHandover = 5,
  CriticalAlert = 6,
}

export enum OperationTriggerMode {
  Completion = 1,
  Scheduled = 2,
  Threshold = 3,
}

export enum OperationTriggerScheduleType {
  Cron = 1,
  ShiftStart = 2,
  ShiftEnd = 3,
  Interval = 4,
}

export enum OperationTriggerMetricSource {
  MachineFuelLevel = 1,
  MachineEngineHours = 2,
  InventoryStockLevel = 3,
  Sensor = 4,
}

export enum OperationTriggerOperator {
  LessThan = 1,
  LessThanOrEqual = 2,
  GreaterThan = 3,
  GreaterThanOrEqual = 4,
  Equal = 5,
}

export enum OperationTriggerPriority {
  Low = 1,
  Normal = 2,
  High = 3,
  Critical = 4,
}

export enum BlastWindowState {
  Scheduled = 1,
  Active = 2,
  Cleared = 3,
}

export enum DeliveryTicketStatus {
  Draft = 1,
  Arrived = 2,
  InProgress = 3,
  Completed = 4,
  Finalized = 5,
}

export enum MaterialBasis {
  Dry = 1,
  Wet = 2,
}

export enum LossBucket {
  WeatherBlastHold = 1,
  BlockedCrossDept = 2,
  PlannedMaint = 3,
  Breakdown = 4,
  NoOperator = 5,
  NoTask = 6,
  Productive = 7,
  Unattributed = 8,
}
